document.addEventListener('DOMContentLoaded', function() {

    const emailInput = document.querySelector('#k_email_bday_signup input[type="email"]');

    emailInput.addEventListener('focus', function() {
        jQuery('[id="k_email_bday_signup"] .birthday-container').fadeIn(500);
        jQuery('[id="k_email_bday_signup"] button').fadeIn(500);
    });

    KlaviyoSubscribe.attachToForms('#k_email_bday_signup', {
    hide_form_on_success: true,
    custom_success_message: true,
    extra_properties: {
        $source: '$embed',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text',
    },
    success: function ($form) {
        $('.klaviyo-legacy-form .newsletter-fields-container').hide();
    }
    });

    const tooltipIcon = document.querySelector('.tooltip-icon');
    const tooltip = document.querySelector('.tooltip');

    tooltipIcon.addEventListener('click', () => {
      tooltip.classList.toggle('hidden');
    });

    document.addEventListener('click', (event) => {
      if (!tooltipIcon.contains(event.target)) {
        tooltip.classList.add('hidden');
      }
    });

});
